export const donationHero = {
  title: 'Support Our Mission',
  subtitle: 'Your generosity fuels free education, mentorship, and community outreach for Pulau Pinang youth. Every contribution — no matter the size — creates real impact.',
  imageUrl: 'https://readdy.ai/api/search-image?query=Malaysian%20youth%20studying%20together%20in%20bright%20community%20center%2C%20smiling%20faces%2C%20laptops%20and%20books%2C%20warm%20natural%20light%2C%20educational%20environment%2C%20hopeful%20atmosphere&width=1600&height=800&seq=hero-donation&orientation=landscape',
};

export const donationImpact = [
  {
    amount: 'RM 50',
    impact: 'Provides learning materials for one youth for a full month of computer classes',
    icon: 'ri-book-open-line',
  },
  {
    amount: 'RM 100',
    impact: 'Supplies a refurbished laptop to a student from an underserved community',
    icon: 'ri-computer-line',
  },
  {
    amount: 'RM 250',
    impact: 'Sponsors one youth through a complete 8-week digital skills course',
    icon: 'ri-graduation-cap-line',
  },
  {
    amount: 'RM 500',
    impact: 'Funds a community outreach event serving 30-50 families in a local neighborhood',
    icon: 'ri-community-line',
  },
];

export const bankAccounts = [
  {
    bank: 'CIMB Bank',
    accountName: 'PERTUBUHAN INSAN PERWIRA PULAU PINANG',
    accountNumber: '1234-5678901-23-4',
  },
  {
    bank: 'Maybank',
    accountName: 'PERTUBUHAN INSAN PERWIRA PULAU PINANG',
    accountNumber: '5123-4567-8901',
  },
];

export const donationFAQ = [
  {
    question: 'Is my donation tax-deductible?',
    answer: 'Yes, PERTUBUHAN INSAN PERWIRA PULAU PINANG is a registered NGO (PPM-012-10-0609313). Donations are tax-exempt under Malaysian law. Receipts are issued for all contributions.',
  },
  {
    question: 'How is my donation used?',
    answer: '100% of donations go directly toward our programs — computer courses, mentorship, and community outreach. We maintain full transparency and publish annual impact reports.',
  },
  {
    question: 'Can I donate equipment instead of money?',
    answer: 'Absolutely! We accept working laptops, monitors, and computer accessories. Please contact us at insanperwirapenang@gmail.com to arrange equipment donations.',
  },
  {
    question: 'Can I set up a recurring donation?',
    answer: 'Yes, you can set up a standing instruction with your bank using the account details provided above. Please contact us for assistance with recurring donations.',
  },
];